module.exports = __webpack_public_path__ + "static/img/et_04.e3c30de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/et/et_04.jpg
// module id = R0Na
// module chunks = 1